export default __webpack_public_path__ + "static/media/SeñorEquilibristaA.381d43f4.png";